<template>
  <div v-bind:class="articleClass">
    <div class="w-100" v-if="enhance">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#e4e0e0" fill-opacity="1" d="M0,160L120,160C240,160,480,160,720,165.3C960,171,1200,181,1320,186.7L1440,192L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"></path></svg>
    </div>
    <div class="article-body w-100">
      <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 mb-4 mt-4">
        <img v-bind:src="article.image_header.url"
        width="100%"
        v-bind:alt="article.image_header.url"/>
      </div>
      <div class="col-12 mt-4 offset-lg-2 col-lg-8 text-justify letter">
        <h2>{{ article.title[0].text }}</h2>
        <div v-html="richTextAsHtml(article.article_body)"></div>
        <p class="text-end">
            <small>{{ article.author }} - {{displayDate}}</small>
          </p>
      </div>
    </div>
    <div class="w-100" v-if="enhance">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#e4e0e0" fill-opacity="1" d="M0,160L120,160C240,160,480,160,720,165.3C960,171,1200,181,1320,186.7L1440,192L1440,0L1320,0C1200,0,960,0,720,0C480,0,240,0,120,0L0,0Z"></path></svg>
    </div>
  </div>
</template>

<script>
import { richTextAsHtml } from '../prismic';

const padZero = n => ((n < 10) ? `0${n}` : n);

export default {
  name: 'HomeArticle',
  props: {
    article: {
      type: Object,
      required: true,
    },
    enhance: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    richTextAsHtml,
  },
  computed: {
    articleClass() {
      return {
        row: true,
        article: true,
        enhance: this.enhance,
      };
    },
    displayDate() {
      if (!this.article.article_date) {
        return '';
      }
      const d = new Date(this.article.article_date);
      return `${padZero(d.getDate())}/${padZero(d.getMonth() + 1)}/${d.getFullYear()}`;
    },
  },
};
</script>

<style scoped>
.enhance .article-body{
  background-color: #e4e0e0;
}
</style>
